import { render, staticRenderFns } from "./mineOrder.vue?vue&type=template&id=8822c736&scoped=true"
import script from "./mineOrder.vue?vue&type=script&lang=js"
export * from "./mineOrder.vue?vue&type=script&lang=js"
import style0 from "./mineOrder.vue?vue&type=style&index=0&id=8822c736&prod&lang=less&scoped=true"
import style1 from "./mineOrder.vue?vue&type=style&index=1&id=8822c736&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8822c736",
  null
  
)

export default component.exports